import { Helmet } from 'react-helmet';
import { getOriginUrl } from '../url-utils';
import type { BreadcrumbsItemsList } from '../../ui-components/breadcrumbs/types';

export const BreadcrumbSchema = ({
    breadcrumbTrail,
}: {
    breadcrumbTrail: BreadcrumbsItemsList[];
}) => {
    const originUrl = getOriginUrl();

    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbTrail.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@id': `${originUrl}${item.href}`,
                name: item.label,
            },
        })),
    };

    return (
        <Helmet>
            <script type="application/ld+json" data-testid="breadcrumb-schema">
                {JSON.stringify(jsonLd, null, 2)}
            </script>
        </Helmet>
    );
};
